module.exports = __webpack_public_path__ + "img/expand_circle_up.08e3eb7d.svg";